import axios from "axios";
import { useState,useEffect } from "react";
import Failuremessage from "./failuremessage";
import { HashLoader } from "react-spinners";
import { useMediaQuery } from "react-responsive";


export default function Report(){
    const [res,setRes] = useState(null);
    const [fileCountonpage,setFileCount] = useState();
    const [fileloaders,setfileLoaders] = useState([]);
    const [download,setdownload] = useState(false);
    const [loading,setLoading] = useState();
    const [fileres,setfileres] = useState();  
    const [mrnumber,setMrnumber] = useState();
    const rootUrl = "http://localhost:3000";
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
    const localrootUrl = "https://ahkserver.onrender.com";

    async function singlefiledown(event,index) {
      event.preventDefault();
      setfileLoaders(prev => {
        // Create a new array with the updated value at `currentIndex`
        const newFileLoaders = [...prev];
        newFileLoaders[index] = true; // Set the desired index to `true`
        return newFileLoaders;
      });
      try {
          const response = await axios.post(`${localrootUrl}/downloadsingle/${index}`, { mrnumber: mrnumber }, {
              responseType: 'blob', // Important
              responseHeaders: ['content-type'], // To access headers
          });
  
          // Extract content type and determine file extension
          const contentType = response.headers['content-type'];
          let extension = '';
  
          if (contentType.includes('pdf')) {
              extension = 'pdf';
          } else if (contentType.includes('image/jpeg')) {
              extension = 'jpg';
          } else if (contentType.includes('image/png')) {
              extension = 'png';
          } else {
              extension = 'bin'; // Default extension
          }
  
          // Create a link element and use it to download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `reports.${extension}`); // Dynamic filename
          document.body.appendChild(link);
          link.click();
  
          // Clean up
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
      } catch (error) {
          console.error('Error downloading the file', error);
      } finally{
        setfileLoaders(prev => {
          // Create a new array with the updated value at `currentIndex`
          const newFileLoaders = [...prev];
          newFileLoaders[index] = false; // Set the desired index to `true`
          return newFileLoaders;
        });
      }
  }


  useEffect(() => {
    // Create an array with 'fileCountonpage' number of 'false' values
    const initialLoaders = Array(fileCountonpage).fill(false);
    setfileLoaders(initialLoaders);
  }, [fileCountonpage]);


  async function alldown(event){
    event.preventDefault();
    setdownload(true);
    try {
        const response = await axios.post(`${localrootUrl}/file`, { mrnumber: mrnumber}, {
          responseType: 'blob', // Important
        });
        setRes(response);
        setdownload(false);
        // Create a link element, use it to download the file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'files.zip'); // Filename to be downloaded
        document.body.appendChild(link);
        link.click();
  
        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading the file', error);
      }
}

  function showAll(event){
    event.preventDefault();
    setLoading(true);

    const fetchInfo =async ()=>{
      const fileCount = await axios.post(`${localrootUrl}/getfileCount`,{ mrnumber: mrnumber });
      setLoading(false);
      const response = fileCount.data;
      if(response){
        setfileres(response);
        setFileCount(response.FileCount);
      }
    }
    fetchInfo();
  }


    if(fileCountonpage>0){
      return <div className="reportcheck" style={{margin:"10%"}}>
        <form className="allReports">
        {Array.from({ length: fileCountonpage }, (_, index) => (
        <div key={index} className="eachrep">
            <h1 className="titlereport">Report {index+1}</h1>
            <button className="download-button" onClick={(event)=>{singlefiledown(event,index)}}>{fileloaders[index]?<HashLoader loading={fileloaders[index]}/>:"Download"}</button>
        </div>
      ))}
      <button style={{alignSelf:"flex-end",marginTop:isMobile?"5vw":"1vw",backgroundColor:"rgb(246, 77, 77)"}} className="download-button" onClick={alldown}>{download?<HashLoader loading={download}/>:"Download All"}</button>
        </form>
      </div>
    }else{
      return <div className="reportcheck" >
        {/* <form method="post" enctype="multipart/form-data">
            <input type="file" name="reports"/>
            <button></button>
        </form> */}
        <form onSubmit={showAll} className="former" style={{alignItems:"center"}}>
            <label className="mrnumber">Enter MR number</label>
            <input className="inputtext" style={{width:isMobile?"80%":"35vw"}} type="text" onChange={(event)=>{setMrnumber(event.target.value)}} name="mrnumber" placeholder="MR Number...."/>
            <button className="submit" type="submit">Submit</button>
            {loading?<HashLoader size={50} className="newloader" loading={loading}/>:fileres?<Failuremessage isFail={fileres.success?false:true} successmessage={fileres.success} custommessage={fileres.failure}/>:null}
        </form>
    </div>
    }

}